export class CustomerChangeRequest{
    accessToken: string;
    customerIdentity: string;
}